import { ModalParts } from 'BreetComponents';
import { useAutoSettlementApi, useFormStage } from 'BreetHooks';
import { selectSelectedBeneficiary, useAppSelector, useGetBeneficiariesQuery } from 'BreetRedux';

import Destination from './DialogAutomaticSettlement.Destination';
import { type AUTOSETTLEMENTSTAGE, autoSettlementStageTitle } from './DialogAutomaticSettlement.helpers';

const DialogAutomaticSettlement = () => {
	useGetBeneficiariesQuery();

	const selectedBeneficiary = useAppSelector(selectSelectedBeneficiary);

	const { isStageActive, navigator, stageTitle } = useFormStage<AUTOSETTLEMENTSTAGE>(
		'destination',
		['destination', 'otpverification'],
		autoSettlementStageTitle
	);

	const handleAutomaticSettlement = useAutoSettlementApi({
		accountName: selectedBeneficiary?.accountName ?? '',
		accountNumber: selectedBeneficiary?.accountNumber ?? '',
		bankName: selectedBeneficiary?.bankName ?? '',
		id: selectedBeneficiary?._id ?? '',
		autoSettlement: selectedBeneficiary?.autoSettlement,
	});

	return (
		<ModalParts.Wrapper
			title={stageTitle}
			handleBackLink={navigator.prev}
			wrapperClassName='automaticsettlement bg-primary-500'
			root={autoSettlementStageTitle.destination}
		>
			<ModalParts.Stage hide={!isStageActive('destination')}>
				<Destination
					updateAutoSettlement={handleAutomaticSettlement}
					selectedBeneficiary={selectedBeneficiary}
				/>
			</ModalParts.Stage>
		</ModalParts.Wrapper>
	);
};

export default DialogAutomaticSettlement;
